import { render, staticRenderFns } from "./ResultSpecimen.vue?vue&type=template&id=206a795d&scoped=true&"
import script from "./ResultSpecimen.vue?vue&type=script&lang=js&"
export * from "./ResultSpecimen.vue?vue&type=script&lang=js&"
import style0 from "./ResultSpecimen.vue?vue&type=style&index=0&id=206a795d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a795d",
  null
  
)

export default component.exports